/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./accountMgmtRoleEditor.vue?vue&type=template&id=681838b7&scoped=true"
import script from "./accountMgmtRoleEditor.vue?vue&type=script&lang=js"
export * from "./accountMgmtRoleEditor.vue?vue&type=script&lang=js"
import style0 from "./accountMgmtRoleEditor.vue?vue&type=style&index=0&id=681838b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681838b7",
  null
  
)

export default component.exports